<!--
 * @Author: xinxin 18617269361@163.com
 * @Date: 2025-05-06 09:55:54
 * @LastEditors: xinxin 18617269361@163.com
 * @LastEditTime: 2025-05-20 14:34:42
 * @FilePath: \u-h5\src\App.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div id="app">
    <van-tabbar
      v-model="active"
      active-color="#ff0000"
      inactive-color="#666"
      v-if="this.$route.meta.hideTabBar"
      :safe-area-inset-bottom="true"
      :route="true"
    >
      <van-tabbar-item name="bell" icon="wap-home" :to="{ path: '/' }"
        >首页</van-tabbar-item
      >

      <van-tabbar-item name="manager" icon="manager" :to="{ path: '/about' }"
        >我的</van-tabbar-item
      >
    </van-tabbar>
    <router-view />
  </div>
</template>
<script>
export default {
  name: "App",
  data() {
    return {
      active: 0,
    };
  },
};
</script>
<style>
html,
body {
  width: 100%;
  height: 100%;
  color: #333;
  font-size: 16px;
}
#app {
}
</style>
